// truncate string and add ellipsis @ max length

export default function EllipsisFilter() {
  return function (str, maxLength) {
    if (str && str.length > maxLength) {
      return str.substr(0, maxLength) + '...';
    } else {
      return str;
    }
  };
}
